/* eslint-disable no-console */
import ServiceBase from './serviceBase';

class OperEsapService extends ServiceBase {
  downloadDocVersion = async (id: number): Promise<boolean> => {
    await this.download(`operationesap/version/${id}`);
    return true;
  };
}

const operEsrsService = new OperEsapService();

export default operEsrsService;
